var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgImageError = function SvgImageError(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 82 82"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#DC3545",
    fillOpacity: 0.14,
    d: "M6 1.5h70A4.5 4.5 0 0 1 80.5 6v70a4.5 4.5 0 0 1-4.5 4.5H6A4.5 4.5 0 0 1 1.5 76V6A4.5 4.5 0 0 1 6 1.5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#DC3545",
    strokeWidth: 3,
    d: "M6 1.5h70A4.5 4.5 0 0 1 80.5 6v70a4.5 4.5 0 0 1-4.5 4.5H6A4.5 4.5 0 0 1 1.5 76V6A4.5 4.5 0 0 1 6 1.5Z"
  })));
};
export default SvgImageError;